import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RemindersAnalyticsState } from './models/reminders-analytics-state.models';

export const selectRemindersAnalyticsState = createFeatureSelector<RemindersAnalyticsState>('remindersAnalytics');

export const selectRemindersOverview = createSelector(
  selectRemindersAnalyticsState,
  (state: RemindersAnalyticsState) => state.overview
);

export const selectRemindersTrend = createSelector(
  selectRemindersAnalyticsState,
  (state: RemindersAnalyticsState) => state.trend
);

export const selectRemindersLoading = createSelector(
  selectRemindersAnalyticsState,
  (state: RemindersAnalyticsState) => state.loading
);

export const selectRemindersError = createSelector(
  selectRemindersAnalyticsState,
  (state: RemindersAnalyticsState) => state.error
);

export const selectRemindersTracker = createSelector(
  selectRemindersAnalyticsState,
  (state: RemindersAnalyticsState) => state.tracker
);
